import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { httpSuggestionProvider } from './suggestions/http-provider';
import '@nuff/ui/tokens.css';
import '@nuff/ui/styles.css';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

// Composition root: choose the suggestions backend here. Real subdomain
// availability via the public API; other steps are still mock-backed (Bedrock next).
createRoot(rootElement).render(
  <StrictMode>
    <App provider={httpSuggestionProvider} />
  </StrictMode>,
);
